<template>
  <div>
    <v-progress-circular
      v-if="chartStatus.loading && chartOptions.series.length <= 0"
      :indeterminate="true"
      :size="75"
      height="3"
      color="primary"
      class="progress-circular"  />
    <v-progress-linear
      v-if="chartStatus.loading && chartOptions.series.length > 0"
      :indeterminate="true"
      height="3"
      color="primary"
      class="progress-card" />
      <div class="card-body pa-0">
        <apexchart
          v-if="chartOptions.series.length > 0 && chartOptions.xaxis.categories.length > 0"
          ref="chartCompetitorsCoverage"
          type="bar"
          class="competitors-coverage-chart"
          :height="height"
          :options="chartOptions"
          :series="chartOptions.series"/>
        <i-no-data v-if="chartStatus.noData && !chartStatus.loading" heading="Oops!" />
      </div>
  </div>
</template>

<script>
export default {
  name: 'chart',
  props: {
    chartOptions: {
      type: [Object, Array],
      default: null
    },
    chartStatus: {
      type: [Object, Array],
      default: null
    },
    height: {
      type: [Number, String],
      default: 440
    },
    columnWidth: {
      type: [Number, String],
      default: null
    },
    brand: {
      type: [Number, String],
      default: 0
    },
    category: {
      type: [Number, String],
      default: 0
    }
  },
  mounted () {
    if (this.chartOptions.series.length < 1) {
      this.$store.dispatch('competitorsCoverageModule/getChart', {
        brandId: this.brand,
        categoryId: this.category,
        elemRef: this.$refs.chartCompetitorsCoverage,
        elemRefPopup: this.$refs.chartCompetitorsCoveragePopup
      })
    }
  },
  methods: {
    setColumnWidth () {
      if (this.columnWidth) {
        this.$store.commit('competitorsCoverageModule/SET_columnWidth', {width: this.columnWidth})
        if (this.$refs.chartCompetitorsCoverage) {
          this.$refs.chartCompetitorsCoverage.refresh()
        }
      }
    },
    resetColumnWidth () {
      this.$store.commit('competitorsCoverageModule/RESET_columnWidth')
    }
  },
  destroyed () {
    this.resetColumnWidth()
  },
  watch: {
    chartOptions: {
      handler () {
        if (this.$refs.chartCompetitorsCoverage) {
          this.$refs.chartCompetitorsCoverage.refresh()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/competitors-coverage/chart.vue